import React from 'react';
import NewPurchaseCreditNote from 'components/Tvendo/Shopping/Operations/CreditNote/NewPurchaseCreditNote';
import { useParams } from 'react-router-dom';
import ViewPurchaseCreditNote from 'components/Tvendo/Shopping/Operations/CreditNote/ViewPurchaseCreditNote';

export default function () {
  const params = useParams();
  if (params.id === '0') {
    return <NewPurchaseCreditNote />;
  }

  return <ViewPurchaseCreditNote />;
}
